import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { authenticateUser } from "../services/authenticationServices";
import CustomPopup from "../../src/Components/TermsPopup";


const LoginEmail = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  const [authError, setAuthError] = useState();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isCondition, setisCondition] = useState(false);
  const [termsData, settermsData] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    validateForm();
  }, [isSubmitted]);

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const newErrors = {
      email: "",
      password: "",
    };

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!password) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error !== "");
  };

  const handleInputChange = (field, value) => {
    if (field === "email") {
      setEmail(value.trim());
    } else {
      setPassword(value);
    }

    // Only validate if form was previously submitted
    if (isSubmitted) {
      validateForm();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      // await loginEmailApi(email, password);
      try {
        await authenticateUser("email", email, password, "", "");
        navigate("/dashboard");
      } catch (error) {
        setAuthError("Email or password is incorrect");
      }
    } catch (error) {
      setErrors({
        ...errors,
        general: error.response?.data?.detail || "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="vh-100">
      <div className="d-flex flex-column flex-md-row h-100 ">
        {/* Left Section */}
        <div className="d-flex w-58 max-md-w-100 login-banner-container">
          <div className="d-flex flex-grow-1 flex-column justify-content-center align-items-center">
            <img
              loading="lazy"
              src="assets/landingpage/images/Login.jpg  "
              alt="Login illustration"
              className="illustration-image"
              style={{
                mixBlendMode: "multiply",
              }}
            />
          </div>
        </div>

        {/* Right Section */}
        <div className="flex-grow-1 w-42">
          <main className="d-flex flex-column justify-content-center h-100 bg-white rounded">
            <a
              href="/"
              className="d-flex justify-content-center image-container"
              data-discover="true"
            >
              <img
                loading="lazy"
                src="assets/images/logo.svg"
                alt="Company logo"
                className="z-10  m-0  w-120 md-w-173   company-image"
              />
            </a>
            <h1
              id="login-heading"
              className="mt-4 text-center text-dark fw-bold"
            >
              Login
            </h1>
            <form className="mt-4">
              {/* Email Field */}
              <div className="form__group">
                <input
                  type="email"
                  className={`form__field ${
                    isSubmitted && errors.email ? "is-invalid" : ""
                  }`}
                  placeholder="Email"
                  name="email"
                  id="email"
                  required
                  value={email}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                />
                <label htmlFor="email" className="form__label">
                  Email<span className="text-danger">*</span>
                </label>
                <img
                  loading="lazy"
                  src="assets/landingpage/images/inbox.svg"
                  alt=""
                  aria-hidden="true"
                  className="input-icon"
                />
              </div>
              {isSubmitted && errors.email && (
                <div className="text-danger small mt-1">{errors.email}</div>
              )}

              {/* Password Field */}
              <div className="form__group">
                <input
                  type={showPassword ? "text" : "password"}
                  className={`form__field ${
                    isSubmitted && errors.password ? "is-invalid" : ""
                  }`}
                  placeholder="Password"
                  name="password"
                  id="password"
                  required
                  value={password}
                  onChange={(e) =>
                    handleInputChange("password", e.target.value)
                  }
                />
                <label htmlFor="password" className="form__label">
                  Password<span className="text-danger">*</span>
                </label>
                <img
                  loading="lazy"
                  src={`assets/landingpage/images/${
                    showPassword ? "eye-off.svg" : "eye.svg"
                  }`}
                  alt=""
                  style={{ padding: showPassword ? "6px" : "0px" }}
                  aria-hidden="true"
                  className="input-icon cursor-pointer"
                  onClick={togglePasswordVisibility}
                />
              </div>
              {isSubmitted && errors.password && (
                <div className="text-danger small mt-1">{errors.password}</div>
              )}

              {/* Remember Me and Forgot Password */}
              <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                <div className="form-check-container">
                  <input
                    type="checkbox"
                    name="remember"
                    id="remember"
                    className="form-check-input-container"
                  />
                  <label htmlFor="remember" className="form-check-label">
                    Remember me
                  </label>
                </div>
                <Link
                  className="text-decoration-none text-info fw-boldy"
                  to="/forget-password"
                >
                  Forgot password?
                </Link>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="btn btn-info text-white rounded-pill w-100 login-button mb-3"
                disabled={loading}
                onClick={handleSubmit}
              >
                {loading ? "Please wait..." : "Login"}
              </button>

              {loading && (
                <div className="loader-container">
                  <div className="loader"></div>
                </div>
              )}

              {/* Alternate Login */}
              <p className="text-center mb-3">
                or{" "}
                <Link className="login-email-link ms-1" to="/login">
                  Log in via Mobile Number
                </Link>
              </p>
              <p className="terms">
                By using askmntor, you agree to our{" "}
                <span
                  className="condition"
                  onClick={() => {
                    settermsData("TermsData");
                    setisCondition(true);
                  }}
                >
                  Terms
                </span>{" "}
                and{" "}
                <span
                  className="condition"
                  onClick={() => {
                    settermsData("privacy");
                    setisCondition(true);
                  }}
                >
                  Privacy Policy
                </span>
                .
              </p>
              {isCondition && (
                <CustomPopup data={termsData} setisCondition={setisCondition} />
              )}
              <div className="text-danger small mt-1">{authError}</div>

              {/* Sign Up Link */}
              {/* <p className="text-center">
                Don't have an account?{" "}
                <Link
                  className="text-info fw-bold text-decoration-none"
                  to="/signup"
                >
                   Sign Up
                </Link>
              </p> */}
            </form>
          </main>
        </div>
      </div>
    </section>
  );
};

export default LoginEmail;
